/* global axios */
import ApiClient from './ApiClient';

class SquadBiAPI extends ApiClient {
  constructor() {
    super('squad_bi_reports', { accountScoped: true });
  }

  // Get available reports for the account's business group
  getReports() {
    return axios.get(this.url);
  }

  // List all available business groups (admin only)
  getBusinessGroups() {
    return axios.get(`${this.url}/business_groups`);
  }

  // Configure business group for the account (admin only)
  configureBusinessGroup(businessGroup) {
    return axios.put(`${this.url}/configure`, {
      business_group: businessGroup,
    });
  }

  // Force authentication and store token (admin only)
  authenticate() {
    return axios.post(`${this.url}/authenticate`);
  }

  // Test complete connection (admin only)
  testConnection() {
    return axios.post(`${this.url}/test_connection`);
  }

  // Get current Squad BI configuration
  getConfiguration() {
    return axios.get(`${this.url}/configuration`);
  }
}

export { SquadBiAPI };
export default new SquadBiAPI();
